<template>
  <div id="app">
    <header-component></header-component>
        <router-view></router-view>
    <footer-component></footer-component>
  </div>
</template>

<script>

import headerComponent from "./components/layouts/header";
import footerComponent from "./components/layouts/footer";
export default {
  name: "app",
  components: {
    headerComponent,
    footerComponent,
  },
  data() {
    return {
      msg: "Welcome to Your Vue.js App",
    };
  },
  mounted() {
    console.log(`Working api url '${process.env.API_URL}'`);
  },
};


</script>

<style>
.invalid-feedback{
  display: block !important;
}
.spinner {
  /* border: 1px solid; */
  position: fixed;
  z-index: 10000;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
  margin: auto;
  background: #dcdcdc
    url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='40' height='2' viewBox='0 0 50 50'%3E%3Cpath d='M28.43 6.378C18.27 4.586 8.58 11.37 6.788 21.533c-1.791 10.161 4.994 19.851 15.155 21.643l.707-4.006C14.7 37.768 9.392 30.189 10.794 22.24c1.401-7.95 8.981-13.258 16.93-11.856l.707-4.006z'%3E%3CanimateTransform attributeType='xml' attributeName='transform' type='rotate' from='0 25 25' to='360 25 25' dur='0.6s' repeatCount='indefinite'/%3E%3C/path%3E%3C/svg%3E")
    center / contain no-repeat;
  opacity: 0.8;
}

/* .router-link-exact-active{
  color: #2B3135;
} */
.navbar-nav li a.router-link-exact-active:before {
    content: "";
    position: absolute;
    left: 0;
    top: -10px;
    background: #FC6D4C;
    width: 25px;
    height: 3px;
    border-radius: 10px;
}
.router-link-exact-active{
  color: #2B3135;
}
.text-right {
  text-align: end !important;
}
.select-menu{
  border: 1px solid #DCDCDC;
    border-radius: 10px;
    padding: 15px 15px;
    width: 100%
}
.pointer{
  cursor: pointer;
}
.schedule_value input[type="number"] {
    border: 1px solid #DCDCDC;
    border-radius: 10px;
    text-align: center;
    width: 80px;
    padding: 18px 5px;
    font-size: 22px;
    margin: 0 20px;
}
.area_input input[type="email"]{
    background: transparent;
    border: none;
    width: 100%;
    padding: 0 15px;
}
/* .navbar-nav li a.active:before{
      content: "";
    position: absolute;
    left: 0;
    top: -10px;
    background: #FC6D4C;
    width: 25px;
    height: 3px;
    border-radius: 10px;
} */

.area_staus_label {
   
    padding: 5px;
    max-width: 500px;
    display: flex;
    justify-content: space-between;
}
.not_allowed_btn{
  cursor: not-allowed !important;
  background: gray  !important;
}
.btn_gray{
   background: gray  !important;
}
</style>



// WEBPACK FOOTER //
// src/App.vue